import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import ClosebookActions from "../../../../reducers/modules/accounting/closebook/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "accounting/closebook";

export default class ClosebookMiddleware {
  static reset() {
    return (dispatch) => {
      dispatch(ClosebookActions.beforeCheck());
      ClosebookMiddleware.check(dispatch);
    };
  }

  static process(params) {
    return (dispatch) => {
      dispatch(ClosebookActions.beforeCheck());
      ClosebookMiddleware.runProcess(dispatch, params);
    };
  }

  static open(params) {
    return (dispatch) => {
      dispatch(ClosebookActions.beforeCheck());
      ClosebookMiddleware.runOpen(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static search(params) {
    return (dispatch) => {
      dispatch(ClosebookActions.beforeSearch());
      ClosebookMiddleware.runSearch(dispatch, params);
    };
  }

  static runSearch(dispatch, params) {
    axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ClosebookMiddleware.getToken()}`
      },
      url: url+'/log-open',
      responseType: 'json',
      params: params
    })
      .then((response) => {

        if (response && response.status === 200 && response.data) {
          dispatch(ClosebookActions.afterSearch(response.data.result));
        }
      })
      .catch((error) => {
        ClosebookMiddleware.alertHendler(dispatch, error)
      });
  }

  static check(dispatch) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ClosebookMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ClosebookActions.afterCheck(response.data.result));
        }
      })
      .catch((error) => {
        ClosebookMiddleware.alertHendler(dispatch, error);
      });
  }

  static runOpen(dispatch, data) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ClosebookMiddleware.getToken()}`,
      },
      url: url + "/open",
      responseType: "json",
      data: data,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ClosebookActions.afterCheck(response.data.result));
        }
      })
      .catch((error) => {
        ClosebookMiddleware.alertHendler(dispatch, error);
      });
  }

  static runProcess(dispatch, data) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ClosebookMiddleware.getToken()}`,
      },
      url: url + "/process",
      responseType: "json",
      data: data,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ClosebookActions.afterCheck(response.data.result));
        }
      })
      .catch((error) => {
        ClosebookMiddleware.alertHendler(dispatch, error);
      });
  }

  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(ClosebookActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(ClosebookActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
